export default {
  get: {
    method: 'post',
    url: '/client/journey-schedule'
  },
  getLocations: {
    method: 'get',
    url: '/client/journey-schedule/locations'
  },
  confirm: {
    method: 'post',
    url: '/client/journey-schedule/confirm/ID'
  },
  manual: {
    method: 'post',
    url: '/client/journey-schedule/manual'
  },
  setting: {
    get: {
      method: 'get',
      url: '/client/journey-schedule/setting'
    },
    update: {
      method: 'post',
      url: '/client/journey-schedule/setting'
    },
    reset: {
      method: 'post',
      url: '/client/journey/reset'
    }
  }
}
